import { ConfigFn } from '@config/types'

const config = (({ apiEnvironment }) => {
  const scriptVersion = '9.2.1'
  return {
    clientScript: `https://jsclient.aureus.ringpublishing.com/aureus-js-client/${scriptVersion}/aureusjsclient.js`,
    endpoint:
      'https://recommendations-ringier-ch.aureus.ringpublishing.com/v1/recommend',
    fallbackEndpoint:
      'https://fallback-ringier-ch.aureus.ringpublishing.com/v1/recommend',
    clientUUID: '5af519bf-788a-4c94-b65b-54e7cd74efd7',
    apiKey: 'ced893d5-8441-4696-9450-276ec0431fd7',
    aureusEnvironment: apiEnvironment === 'prod' ? 'prod' : 'stg',
  } as const
}) satisfies ConfigFn

export default config
